// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteSecurityGroupModal_dialog__2aoZf"};